/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Text Edit Icon component.
 */
export const TextEditIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.5 5C10.9142 5 11.25 5.33579 11.25 5.75V19.25C11.25 19.6642 10.9142 20 10.5 20C10.0858 20 9.75 19.6642 9.75 19.25V17.75H4.75C3.23122 17.75 2 16.5188 2 15V10C2 8.48122 3.23122 7.25 4.75 7.25H9.75V5.75C9.75 5.33579 10.0858 5 10.5 5ZM19.75 7.25C21.2688 7.25 22.5 8.48122 22.5 10V15C22.5 16.5188 21.2688 17.75 19.75 17.75H12.75V16.25H19.75C20.4404 16.25 21 15.6904 21 15V10C21 9.30964 20.4404 8.75 19.75 8.75H12.75V7.25H19.75ZM4.75 8.75C4.05964 8.75 3.5 9.30964 3.5 10V15C3.5 15.6904 4.05964 16.25 4.75 16.25H9.75V8.75H4.75Z' fill={iconColor} />
    </svg>
  );
};

export default TextEditIcon;
